// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle-tooltip[data-v-f827469c]{position:absolute;inset:0;border-radius:50%}[data-v-f827469c] .nav-dropdown{width:368px;max-width:100vw}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
